export default "<div class=\"select-dropdown-panel-items\">\n  <div #content>\n    <ng-content></ng-content>\n  </div>\n  \n</div>"